// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oEdC","buttons":"styles_buttons__10lMd"};